import { inject } from 'mobx-react';
import { EnvLabelComponent } from './component';
export const EnvLabel = inject(({ ui }) => ({
    envLabel: ui.environmentLabel,
}))(EnvLabelComponent);
//# sourceMappingURL=index.js.map